import { Injectable } from '@angular/core';
import { UtilService } from '../utils/util.service';

@Injectable({
  providedIn: 'root',
})

// Wrapper for sessionStorage (alues get clear during log out)
export class SessionService {
  public getItem(key: string, defaultValue?: any): any {
    let item = sessionStorage.getItem(UtilService.encryptData(key));
    const itemExists = item && item !== 'undefined';
    if (itemExists) {
      const isString = typeof item === 'string';
      try {
        item = isString ? JSON.parse(UtilService.decryptData(item)) : defaultValue;
      } catch (e) {
        item = defaultValue;
      }
      return item;
    }
    return defaultValue;
  }

  public setItem(key: string, value: any) {
    sessionStorage.setItem(UtilService.encryptData(key), UtilService.encryptData(value));
  }

  public removeItem(key: string) {
    sessionStorage.removeItem(UtilService.encryptData(key));
  }
}
